'use client'
import React, { FC } from 'react'
import ButtonGradientEpic from '@/components/button-gradient-epic'
import DelistButton from '@/components/inscription-actions/inscription-action-cancel'
import event from '@/utils/event'
import useSatoshiPrice from '@/utils/hooks/useSatoshiPrice'
import { NETWORK } from '@/utils/constants'
import { formatSatsPer } from '@/utils/format-sats'

const InscriptionCardSmall: FC<{
	rune: any
	ticker: string
	description: string
	children?: React.ReactNode
	onList: (evt: any) => void
	onTransfer: (evt: any) => void
	symbol: string
}> = (props) => {
	const { rune, ticker: _ticker, description, onList, onTransfer, symbol } = props

	const price = useSatoshiPrice(rune?.escrow?.satoshi_price)
	const { sats, per } = formatSatsPer(rune?.escrow?.satoshi_price / parseFloat(rune.amount))
	const outpointPrice = useSatoshiPrice(rune.sats)

	const canExtract = rune.sats > 10000

	return (
		<div className="bg-background p-4 w-full rounded flex gap-4 flex-col">
			<div className="flex items-center gap-2">
				<div className="flex flex-col">
					<p className="text-xs semibold">{description}</p>
				</div>
				<div className="grow" />
				<div className="flex gap-2">
					{canExtract && (
						<ButtonGradientEpic
							className="h-[32px] rounded-full text-sm font-semibold"
							onClick={onTransfer}
						>
							Extract {outpointPrice} {NETWORK}
						</ButtonGradientEpic>
					)}
					{!canExtract && !rune.escrow && (
						<ButtonGradientEpic
							className="h-[32px] rounded-full text-sm font-semibold"
							onClick={onList}
						>
							List
						</ButtonGradientEpic>
					)}
					{!!rune?.escrow && (
						<>
							<div className="flex justify-right flex-col">
								<p className="text-sm font-bold">
									{price} {NETWORK}
								</p>
								<p className="text-xs font-bold text-muted-foreground">
									{sats} {per}/{symbol}
								</p>
							</div>
							<DelistButton
								id={rune.outpoint}
								rune={true}
								onComplete={() => {
									event.emit('list-item', {
										type: 'cancel',
										cancelled: true,
										id: rune.outpoint
									})
								}}
							/>
						</>
					)}
				</div>
			</div>
			{props.children}
		</div>
	)
}

export default InscriptionCardSmall
